module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "pagination-order-window"
  }, [_c('div', {
    staticClass: "pagination-order-window-step"
  }, [_c('div', {
    staticClass: "pagination paginationPrev",
    class: {
      notPagination: !_vm.paginationPrev
    }
  }, [(_vm.paginationPrev) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'summaryOrderWindow',
        params: {
          id: _vm.paginationPrev.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-backward"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.paginationPrev.name))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination paginationNext",
    class: {
      notPagination: !_vm.paginationNext
    }
  }, [(_vm.paginationNext) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'summaryOrderWindow',
        params: {
          id: _vm.paginationNext.id
        }
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.paginationNext.name))]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-forward"
  })]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-308e1b37","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/summary-common/paginationOrderWindow.vue
// module id = 3108
// module chunks = 0